<div class="d-flex align-items-center">
  <app-search (onValueChange)="onSearchChange($event)"></app-search>
  <app-dropdown
    class="mx-2 filters-w"
    [items]="[]"
    [placeholder]="'filter_by_status' | translate"
    [clearable]="true"
    (onValueChange)="onFilterChange('status', $event)"
    [closeOnSelect]="true"
  ></app-dropdown>
  @if (selectionTable.selected.length) {
    <div>
      <app-button #t="matMenuTrigger" [matMenuTriggerFor]="menu">
        <div class="d-flex flex-nowrap align-items-center">
          <span class="selected_dropdown">({{ selectionTable.selected.length }}) {{ 'selected' | translate }}</span>
          <app-icon class="align-middle selected_dropdown">{{ t.menuOpen ? 'expand_less' : 'expand_more' }}</app-icon>
        </div>
      </app-button>
      <mat-menu #menu="matMenu" yPosition="below" xPosition="before" class="p-0">
        @for (item of bulkActionList; track item; let i = $index) {
          <button mat-menu-item (click)="bulkActionPopup(item)">
            {{ item.label }}
          </button>
        }
      </mat-menu>
    </div>
  }
  <div class="flex-fill"></div>
  <!--        <app-button (onChangeClick)="openDialogCreateChannel()">Створити канал</app-button>-->
</div>
@if (isLoader) {
  <div class="d-flex justify-content-center">
    <app-loader size="small"></app-loader>
  </div>
} @else {
  @if (dataSource$ | async; as dataSource) {
    <app-table
      class="w-100"
      [dataSource]="dataSource"
      [visibleColumnKeys]="visibleColumns"
      (onSortChange)="onSortChange($event)"
      (onPaginationChange)="onPaginationChange($event)"
      (menuSelected)="onActionChange($event)"
      [showUpPagination]="true"
      [selection]="selectionTable"
    ></app-table>
  }
}
